import { render, staticRenderFns } from "./Period.vue?vue&type=template&id=48c98f2e&scoped=true&"
import script from "./Period.vue?vue&type=script&lang=js&"
export * from "./Period.vue?vue&type=script&lang=js&"
import style0 from "./Period.vue?vue&type=style&index=0&id=48c98f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c98f2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48c98f2e')) {
      api.createRecord('48c98f2e', component.options)
    } else {
      api.reload('48c98f2e', component.options)
    }
    module.hot.accept("./Period.vue?vue&type=template&id=48c98f2e&scoped=true&", function () {
      api.rerender('48c98f2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/Period.vue"
export default component.exports